"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _context = require("./context");

var _indicators = _interopRequireDefault(require("./indicators"));

var _animationButton = _interopRequireDefault(require("./animationButton"));

var _utils = require("./utils");

var _container = _interopRequireDefault(require("./styled/container"));

var _autoplay = _interopRequireDefault(require("./styled/autoplay"));

var _imagesUl = _interopRequireDefault(require("./styled/imagesUl"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * A carouselCard allows multiple pieces of featured content to occupy an allocated amount of space.
 */
var CarouselCard = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(CarouselCard, _Component);

  var _super = _createSuper(CarouselCard);

  function CarouselCard(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, CarouselCard);
    _this = _super.call(this, props);
    _this.container = /*#__PURE__*/_react["default"].createRef();
    _this.registerChild = _this.registerChild.bind((0, _assertThisInitialized2["default"])(_this));
    _this.unregisterChild = _this.unregisterChild.bind((0, _assertThisInitialized2["default"])(_this));
    _this.setActiveItem = _this.setActiveItem.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleOnClick = _this.handleOnClick.bind((0, _assertThisInitialized2["default"])(_this));
    var disableAutoScroll = _this.props.disableAutoScroll;
    _this.state = {
      childrenRegistred: [],
      activeItem: undefined,
      isAnimationPaused: disableAutoScroll,
      privateRegisterChild: _this.registerChild,
      privateUnregisterChild: _this.unregisterChild
    };
    _this.containerRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }

  (0, _createClass2["default"])(CarouselCard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var isAnimationPaused = this.state.isAnimationPaused;

      if (!isAnimationPaused) {
        this.startAnimation();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.animationTimeout) {
        clearTimeout(this.animationTimeout);
      }
    }
  }, {
    key: "getContainerStyle",
    value: function getContainerStyle() {
      var style = this.props.style;
      return _objectSpread(_objectSpread({}, (0, _utils.getCarouselCardContainerStyles)(this.container.current)), style);
    }
  }, {
    key: "setActiveItem",
    value: function setActiveItem(id) {
      this.setState({
        activeItem: id,
        isAnimationPaused: true
      });
    }
  }, {
    key: "startAnimation",
    value: function startAnimation() {
      var _this2 = this;

      var _this$props = this.props,
          scrollDuration = _this$props.scrollDuration,
          disableAutoRefresh = _this$props.disableAutoRefresh;
      this.animationTimeout = setTimeout(function () {
        var isAnimationPaused = _this2.state.isAnimationPaused;

        if (!isAnimationPaused) {
          var _this2$state = _this2.state,
              childrenRegistred = _this2$state.childrenRegistred,
              activeItem = _this2$state.activeItem;
          var selectedItemIndex = (0, _utils.getItemIndex)(childrenRegistred, activeItem);
          var isLastItem = selectedItemIndex === childrenRegistred.length - 1;
          var nextItem = isLastItem ? 0 : selectedItemIndex + 1;

          if (isLastItem && disableAutoRefresh) {
            _this2.setState({
              isAnimationPaused: true
            });
          } else {
            _this2.startAnimation();

            _this2.setState({
              activeItem: childrenRegistred[nextItem].indicatorID
            });
          }
        }
      }, scrollDuration * 1000);
    }
  }, {
    key: "handleOnClick",
    value: function handleOnClick() {
      var isAnimationPaused = this.state.isAnimationPaused;

      if (isAnimationPaused) {
        this.startAnimation();
      }

      this.setState({
        isAnimationPaused: !isAnimationPaused
      });
    }
  }, {
    key: "registerChild",
    value: function registerChild(child) {
      var childrenRegistred = this.state.childrenRegistred;

      var _getChildTabNodes = (0, _utils.getChildTabNodes)(this.containerRef.current),
          _getChildTabNodes2 = (0, _toArray2["default"])(_getChildTabNodes),
          nodes = _getChildTabNodes2.slice(0);

      var newChildren = (0, _utils.insertChildOrderly)(childrenRegistred, child, nodes);
      this.setState({
        childrenRegistred: newChildren,
        activeItem: newChildren[0].indicatorID
      });
    }
  }, {
    key: "unregisterChild",
    value: function unregisterChild(indicatorID) {
      var childrenRegistred = this.state.childrenRegistred;
      var newChildren = childrenRegistred.filter(function (child) {
        return child.indicatorID !== indicatorID;
      });
      this.setState({
        childrenRegistred: newChildren,
        activeItem: newChildren[0].indicatorID
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          id = _this$props2.id,
          className = _this$props2.className;
      var _this$state = this.state,
          childrenRegistred = _this$state.childrenRegistred,
          activeItem = _this$state.activeItem,
          isAnimationPaused = _this$state.isAnimationPaused;
      return /*#__PURE__*/_react["default"].createElement(_container["default"], {
        className: className,
        style: this.getContainerStyle(),
        id: id,
        ref: this.container
      }, /*#__PURE__*/_react["default"].createElement(_autoplay["default"], null, /*#__PURE__*/_react["default"].createElement(_animationButton["default"], {
        onClick: this.handleOnClick,
        isAnimationPaused: isAnimationPaused
      })), /*#__PURE__*/_react["default"].createElement(_imagesUl["default"], {
        ref: this.containerRef
      }, /*#__PURE__*/_react["default"].createElement(_context.Provider, {
        value: this.state
      }, children)), /*#__PURE__*/_react["default"].createElement(_indicators["default"], {
        carouselChildren: childrenRegistred,
        onSelect: this.setActiveItem,
        selectedItem: activeItem
      }));
    }
  }]);
  return CarouselCard;
}(_react.Component);

exports["default"] = CarouselCard;
CarouselCard.propTypes = {
  /** The auto scroll duration. The default is 5 seconds, after that the next image is displayed. */
  scrollDuration: _propTypes["default"].number,

  /** Specifies whether auto scroll is disabled. The default value is false. */
  disableAutoScroll: _propTypes["default"].bool,

  /** Specifies whether the carousel should stop looping from the beginning after the last item is displayed.
   * The default value is false. */
  disableAutoRefresh: _propTypes["default"].bool,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes["default"].object,

  /**
   * This prop that should not be visible in the documentation.
   * @ignore
   */
  children: _propTypes["default"].node,

  /** The id of the outer element. */
  id: _propTypes["default"].string
};
CarouselCard.defaultProps = {
  scrollDuration: 5,
  disableAutoScroll: false,
  disableAutoRefresh: false,
  className: undefined,
  style: undefined,
  children: null,
  id: undefined
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/CarouselCard/index.js
// module id = e1+z
// module chunks = 0